import { useEffect } from 'react';

import { IS_PRODUCTION_BUILD } from '@/shared/environments';

import { useHubSpotChatStore } from './useHubSpotChatStore';

export const useInitHubSpotChat = () => {
  const onWidgetReady = useHubSpotChatStore((state) => state.onWidgetReady);
  const onUnreadConversationCountChanged = useHubSpotChatStore((state) => state.onUnreadConversationCountChanged);

  useEffect(() => {
    if (!IS_PRODUCTION_BUILD) {
      return;
    }

    const initHubSpot = () => {
      if (window.HubSpotConversations) {
        window.HubSpotConversations.widget.load({ widgetOpen: false });
        window.HubSpotConversations.on('widgetLoaded', onWidgetReady);
        window.HubSpotConversations.on('unreadConversationCountChanged', onUnreadConversationCountChanged);
      }
    };

    if (window.HubSpotConversations) {
      initHubSpot();
    } else {
      window.hsConversationsOnReady = [...(window.hsConversationsOnReady || []), initHubSpot];
    }

    return () => {
      if (window.HubSpotConversations) {
        window.HubSpotConversations.off('widgetLoaded', onWidgetReady);
        window.HubSpotConversations.off('unreadConversationCountChanged', onUnreadConversationCountChanged);
      }
    };
  }, [onUnreadConversationCountChanged, onWidgetReady]);
};
